import React, { useState, useEffect, useMemo } from 'react';
// import { useSelector } from 'react-redux';
import { t } from '../../content';
import { useLocale } from '../../locale';
import Form from '../../components/reusableElementsComponents/Form';
import Button from '../../components/reusableElementsComponents/Button';
import WriteAccessGuard from '../../components/reusableElementsComponents/WriteAccessGuard';
import Loading from '../../components/reusableElementsComponents/Loading';
import Loader from '../../components/reusableElementsComponents/Loader';
import person from '../../assets/images/icons/person.svg';
import letter from '../../assets/images/icons/letter.svg';
import * as Utilities from "../../Utilities";
import B2BApiService from "../../B2bApiService";
import { ToastContainer, toast } from "react-toastify";

import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

function GeneralSettings() {
  const { locale } = useLocale();
  // const data = useSelector(state => state.contentfulData.all['settings']);

  // Corporate user data: The user who is logged in and using the current account
  const [userData, setUserData] = useState({});

  const [template, setTemplate] = useState({});
  const [loader, setLoader] = useState(false);
  const [anonymouseResultsStatus, setAnonymouseResultsStatus] = useState(false);

  const b2bServiceObj = useMemo(() => {
    return new B2BApiService();
  }, []);

  useEffect(() => {
    if (Utilities.isEmptyObject(userData)) {
      b2bServiceObj.LoadUserData((userData) => {
        setUserData(userData)
        setAnonymouseResultsStatus(userData.anonymous_results ? userData.anonymous_results : false)
      })
    }
  }, [b2bServiceObj, userData]);

  useEffect(() => {
    if (!Utilities.isEmptyObject(userData)) {
      setTemplate({
        fields: [
          {
            title: t('common.fields.firstName'),
            type: 'text',
            name: 'firstName',
            placeholder: t('common.placeholders.startTyping'),
            icon: person,
            defaultValue: userData.first,

          },
          {
            title: t('common.fields.lastName'),
            type: 'text',
            name: 'lastName',
            placeholder: t('common.placeholders.startTyping'),
            icon: person,
            defaultValue: userData.last,

          },
          {
            title: t('common.fields.emailAddress'),
            type: 'email',
            name: 'emailAddress',
            placeholder: t('common.placeholders.startTyping'),
            defaultValue: userData.email,
            icon: letter,

          }
        ]
      })
    }
  }, [userData, locale]);

  const onSubmit = async (values) => {
    setLoader(true);

    // Save user account details
    const savingAccountDetails = toast.loading(t('account.toasts.updatingAccount'))
    try {
      const saveAccountDetailsResponse = await b2bServiceObj.SaveUserData({
        "first":values?.firstName?.length > 0 ? values?.firstName : userData.first,
        "last":values?.lastName?.length > 0 ? values?.lastName : userData.last,
        "email":values?.emailAddress?.length > 0 ? values?.emailAddress : userData.email,
        "anonymous_results" : anonymouseResultsStatus
      })
      if (saveAccountDetailsResponse) {
        toast.update(savingAccountDetails, { render: t('account.toasts.accountUpdated'), type: "success", isLoading: false, autoClose: 2000, closeButton: true, hideProgressBar: true });
      } else {
        toast.update(savingAccountDetails, { render: t('account.toasts.accountUpdateError'), type: "error", isLoading: false, autoClose: 2000, closeButton: true, hideProgressBar: true });
      }
    } catch (error) {
      toast.update(savingAccountDetails, { render: t('account.toasts.accountUpdateError'), type: "error", isLoading: false, autoClose: 2000, closeButton: true, hideProgressBar: true });
    }

    setLoader(false);
    // window.scrollTo(0, 0);
  };

  const handleAnonymousResultChange = (event) =>{
    setAnonymouseResultsStatus(event.target.checked)
  }

  return (
    <>
      {userData.first ? (
        <div className="settings-page">
          {!Utilities.isEmptyObject(template) && 
          <div className="settings-page-wrapper">
            <div className="settings">
              <ToastContainer />
              <Form
                template={template}
                watchFields={['firstName', 'lastName']}
                onSubmit={onSubmit}
              >
                <FormGroup>
                  <label style={{color : "#979797"}} htmlFor="Candidates/Team Members names hidden">{t('account.hideCandidateNames')} </label>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography><b>{t('common.labels.off')}</b></Typography>
                    <Switch
                        checked={anonymouseResultsStatus}
                        onChange={handleAnonymousResultChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                    <Typography><b>{t('common.labels.on')}</b></Typography>
                  </Stack>
                </FormGroup>
                <br/>

                {loader ?
                  <Button btnstyle={'mazhrBtn light-grey'}>
                    <Loader />
                  </Button> 
                  :
                  <WriteAccessGuard>
                    <Button type='submit' btnstyle={'mazhrBtn default-green white'} onSubmit={onSubmit}>
                    {t('account.saveChanges')}
                  </Button>
                  </WriteAccessGuard>
                }
                <div style={{marginTop: "20px", display: "flex"}}>
                  <i className="pi pi-info-circle" style={{'fontSize': '2em', marginRight: "10px"}}></i>
                  <p>{t('account.deleteAccount')}</p>
                </div>
              </Form>
            </div>
          </div>}
        </div>) 
        :
        <Loading />
      }
    </>
  )
}

export default GeneralSettings
